var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"tile":true,"rounded":"0"}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.$t('app.logo')}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }